import type { UserProfile } from "@serophin/nottldr-shared";
import { useState } from "preact/hooks";
import { route } from "preact-router";
import { endSession } from "../../platform/session";
import { DeleteAccountModal } from "./DeleteAccountModal";
import { UserInfo } from "./UserInfo";

/** Signs out, then leaves the signed-in pages for the landing page. */
const signOut = async (): Promise<void> => {
  await endSession();
  route("/");
};

export const AccountSettings = ({ profile }: { profile: UserProfile }) => {
  const [deleting, setDeleting] = useState(false);

  return (
    <div class="space-y-6">
      <UserInfo email={profile.email} name={profile.name} />
      <button
        type="button"
        onClick={signOut}
        class="w-full py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
        data-test-click="sign-out"
      >
        Sign Out
      </button>
      <div class="text-center pt-4">
        <button
          type="button"
          onClick={() => setDeleting(true)}
          class="text-sm text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300 underline"
          data-test-click="settings-delete-account"
        >
          Delete Account
        </button>
      </div>
      <DeleteAccountModal isOpen={deleting} onClose={() => setDeleting(false)} />
    </div>
  );
};
